export default "__VITE_ASSET__ALtyF$yJ__"